import { z } from 'zod';

function concatOnlyIfDefined(delimiter: string, ...strings: unknown[]): string {
  if (strings.length > 1) {
    let str1 = strings.shift() ?? '';
    let str2 = strings.shift() ?? '';

    if (!str1) {
      str1 = str2;
      str2 = '';
    }

    if (str2) {
      const newString = str1 + delimiter + str2;

      return concatOnlyIfDefined(delimiter, newString, ...strings);
    }

    return concatOnlyIfDefined(delimiter, str1, ...strings);
  }

  return String(strings.pop() || '');
}

function pluralize(count: number, noun: string, suffix = 's') {
  return `${count} ${noun}${count !== 1 ? suffix : ''}`;
}

function numberToOrdinal(number: 1 | 2 | 3 | 4 | 5 | number) {
  switch (number) {
    case 1:
      return 'first';
    case 2:
      return 'second';
    case 3:
      return 'third';
    case 4:
      return 'fourth';
    case 5:
      return 'fifth';
    default:
      return String(number);
  }
}

const emailSchema = z.string().min(1).email();

function isEmail(email?: string) {
  return emailSchema.safeParse(email).success;
}

function limitTo(foo: string | string[], limit: number) {
  if (typeof foo === 'string') {
    return foo.substring(0, limit);
  }

  if (Array.isArray(foo)) {
    return foo.slice(0, limit);
  }

  throw new Error(`first parameter of 'limitTo' must be string or array, instead get ${JSON.stringify(foo)}`);
}

export { concatOnlyIfDefined, pluralize, numberToOrdinal, isEmail, limitTo };
